import copyText from '../lib/copyText';

function copyTarget(element) {
	const targetAttr = element.getAttribute('data-copy');
	const target = element.closest(`[${targetAttr}]`);

	if (!target) {
		return;
	}

	const text = target.getAttribute(targetAttr);

	copyText(text);

	// TODO: This should probably be built-in to the tooltip
	const tooltip = element.querySelector('[data-tooltip]');
	const tooltipText = tooltip.innerHTML;
	tooltip.innerHTML = 'Länk kopierad!';

	element.addEventListener('mouseout', () => {
		tooltip.innerHTML = tooltipText;
	}, { once: true });
}

function delegate(e) {
	const target = e.target.closest('[data-copy]');

	if (target) {
		copyTarget(target);
	}
}

document.body.addEventListener('click', delegate);
